"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasCollectionCapability = exports.COLLECTION_CAPABILITIES = void 0;
exports.COLLECTION_CAPABILITIES = [
    'editInventory',
    'manageMembers',
    'renameCollection',
    'administerInventory',
    'moveItemsOut',
    'viewActivity',
    'manageAdministrators',
    'manageBilling',
    'manageAiPolicy',
    'manageOwnership',
];
const grants = {
    viewer: [],
    editor: ['editInventory'],
    administrator: [
        'editInventory',
        'manageMembers',
        'renameCollection',
        'administerInventory',
        'moveItemsOut',
        'viewActivity',
    ],
    owner: exports.COLLECTION_CAPABILITIES,
};
/** Role grants only: callers must also verify membership and lifecycle. */
const hasCollectionCapability = (role, capability) => { var _a; return role !== undefined && ((_a = grants[role]) === null || _a === void 0 ? void 0 : _a.includes(capability)) === true; };
exports.hasCollectionCapability = hasCollectionCapability;
